import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { PrimaryButton } from "../../../../Components/Buttons/Buttons";
import { SHBox } from "../../../../Components/Box";
import { PatchedPagination } from "../../../../Components/Table/PatchedPagination";
import * as Defaults from "../../../../Globals/Defaults/TableOptions";
import { DarwinTablePageContent } from "../../../../Globals/Styles/AppStyling";
import MaterialTable from "material-table";
import { formatDate, formatIncidentNumber, formatTime } from "../../../../Utils/Format";
import { ToolboxTalkListViewModel } from "./ToolboxTalkViewModel";
import { ToolboxTalkListModel } from "./ToolboxTalkListModel";
import styled from "styled-components";

const Wrapper = styled.div`
    padding: 5px 30px;
`;

interface Props {
    projectId: string;
    projectName: string;
    projectReference: string;
}
export const ToolboxTalksView: React.FC<Props> = observer((props: Props) => {
    const [listViewModel] = useState(() => new ToolboxTalkListViewModel());

    useEffect(() => {
        listViewModel.projectId = props.projectId;
        listViewModel.loadToolboxTalksAndRelated();
    }, []);

    const renderListView = (
        <SHBox>
            <SHBox grid dc={"300px 100px"} alignItems={"flex-end"}>
                <PrimaryButton canExecute={!listViewModel.IsLoading} execute={listViewModel.addToolboxTalkForm} value={"Add"} />
            </SHBox>
            <DarwinTablePageContent>
                <MaterialTable
                    columns={[
                        {
                            title: "Date / time added",
                            field: "createdDate",
                            render: (rowData: ToolboxTalkListModel) => (
                                <SHBox>
                                    <SHBox>{rowData.createdDate ? `${formatDate(rowData.createdDate.toString())} @ ${formatTime(rowData.createdDate.toString())}` : ""}</SHBox>
                                </SHBox>
                            ),
                        },
                        { title: "No. of Individuals", field: "individualCount" },
                        { title: "Talk subject", field: "subject" },
                        { title: "Talk giver", field: "talkerUserName" },
                        {
                            title: "Last updated",
                            field: "lastUpdatedDate",
                            render: (rowData: ToolboxTalkListModel) => (
                                <SHBox>
                                    <SHBox>
                                        {formatDate(rowData.lastUpdatedDate.toString())} @ {formatTime(rowData.lastUpdatedDate.toString())} by
                                    </SHBox>
                                    <SHBox>{`${rowData.lastUpdatedByUserName}`}</SHBox>
                                </SHBox>
                            ),
                        },
                    ]}
                    components={{
                        Pagination: PatchedPagination,
                    }}
                    options={Defaults.GetDarwinTableOptions()}
                    data={listViewModel.toolboxTalkListModels}
                    onRowClick={(e, rowData) => {
                        listViewModel.handleRowClick(e, rowData!);
                    }}
                    title=""
                />
            </DarwinTablePageContent>
        </SHBox>
    );

    return <Wrapper>{renderListView}</Wrapper>;
});
